import React from 'react';
import styled, { css } from 'styled-components';
import { useInView } from 'react-intersection-observer';

import Container from 'gatsby-theme-core/src/components/container';
import Nav from 'gatsby-theme-pages/src/components/nav';
import Logo from 'gatsby-theme-core/src/components/logo';

const Header = ({ className, homepage }) => {
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
  });
  const showStickyHeader = !inView && entry;
  return (
    <>
      <div ref={ref} />
      <HeaderEl
        showStickyHeader={showStickyHeader}
        homepage={homepage}
        className={className}
      >
        <Container>
          <Wrapper>
            <LogoWrapper>
              <Logo />
            </LogoWrapper>
            <Nav listNav />
          </Wrapper>
        </Container>
      </HeaderEl>
    </>
  );
};

const LogoWrapper = styled.div`
  width: 16rem;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

const HeaderEl = styled.header`
  z-index: 9;
  position: sticky;
  top: 0;
  padding: 1rem 0;
  background-color: black;
  transition: .2s;

  ${({ showStickyHeader }) => showStickyHeader && css`
    padding: .5rem 0;
  `}

  ${({ homepage }) => homepage && css`
    position: fixed;
    left: 0;
    right: 0;
  `}

  ${({ homepage, showStickyHeader }) => (homepage && !showStickyHeader) && css`
    background: transparent;
  `}
`;

export default styled(Header)``;
